<template>
  <v-card>
    <v-card-title>
      {{ id === -1 ? 'Thêm mới Template' : 'Cập nhật Template' }}
      <v-spacer />
      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid">
        <!-- Main Template Fields -->
        <v-text-field
          label="Tên"
          v-model="form.name"
          :rules="[v => !!v || 'Bắt buộc']"
          required
        />

        <v-textarea
          label="Nội dung"
          v-model="form.body"
          auto-grow
          rows="3"
          :rules="[v => !!v || 'Bắt buộc']"
          required
        />
        
        <!-- <v-textarea
          label="HTML Template"
          v-model="form.htmlTemplate"
          auto-grow
          rows="3"
          :rules="[v => !!v || 'Bắt buộc']"
          required
        /> -->
        
        <label >HTML Template</label>
        <quill-editor v-model="form.htmlTemplate">
        </quill-editor>

        <file-upload
          label="Ảnh đại diện"
          accept="image/*"
          v-model="form.avatar"
        />
        <file-upload
          label="Tệp đính kèm"
          accept=".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar"
          v-model="form.attachment"
        />

        <!-- Subitem Table (only visible when editing) -->
        <v-card outlined class="mt-4" v-if="id !== -1">
          <v-card-title>
            Danh sách phụ mục <span class="mx-2"></span> {{ syncing }}
            <v-spacer />
            <v-btn color="warning" text @click="applyVariable()" :loading="applying" small>Đồng bộ</v-btn>
            <v-btn small color="teal darken-4" dark @click="addRow">
              <v-icon left small>mdi-plus</v-icon>
              Thêm dòng
            </v-btn>
          </v-card-title>


          <file-upload
          label="Tệp Import"
          accept=".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar"
          :uploadUrl="`ContentTemplate2s/${id}/variables/import`"
        />
          <v-data-table
            :items="form.subItems"
            :headers="subHeaders"
            dense
          >
            <!-- Actions Column -->
            <template v-slot:[`item.actions`]="{ item, index }">
              <v-btn
                icon
                :color="item.editing ? 'green darken-2' : 'blue darken-2'"
                @click="toggleEditSave(item, index)"
              >
                <v-icon>{{ item.editing ? 'mdi-content-save' : 'mdi-pencil' }}</v-icon>
              </v-btn>
              <v-btn icon color="red darken-2" @click="removeRow(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>

            <!-- EmployeeCode & Variables -->
            <template v-slot:[`item.employeeCode`]="{ item }">
              <v-text-field v-model="item.employeeCode" dense hide-details :readonly="!item.editing"></v-text-field>
            </template>
            <template v-slot:[`item.variable1`]="{ item }">
              <v-text-field v-model="item.variable1" dense hide-details :readonly="!item.editing"></v-text-field>
            </template>
            <template v-slot:[`item.variable2`]="{ item }">
              <v-text-field v-model="item.variable2" dense hide-details :readonly="!item.editing"></v-text-field>
            </template>
            <template v-slot:[`item.variable3`]="{ item }">
              <v-text-field v-model="item.variable3" dense hide-details :readonly="!item.editing"></v-text-field>
            </template>
            <template v-slot:[`item.variable4`]="{ item }">
              <v-text-field v-model="item.variable4" dense hide-details :readonly="!item.editing"></v-text-field>
            </template>
            <template v-slot:[`item.variable5`]="{ item }">
              <v-text-field v-model="item.variable5" dense hide-details :readonly="!item.editing"></v-text-field>
            </template>
            <template v-slot:[`item.variable6`]="{ item }">
              <v-text-field v-model="item.variable6" dense hide-details :readonly="!item.editing"></v-text-field>
            </template>
            <template v-slot:[`item.synced`]="{ item }">
              <v-icon v-if="item.synced==true" color="green">mdi-check</v-icon>
              <v-icon v-else color="red">mdi-close</v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn text @click="$emit('close')">Hủy</v-btn>
      <v-btn color="teal darken-4" dark @click="submitForm">
        {{ id === -1 ? 'Lưu' : 'Cập nhật' }}
      </v-btn>
      
      <!-- Apply button -->
      <v-btn color="orange darken-2" dark @click="applyHandler">
        Áp dụng
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ContentTemplateApi from './api'
import FileUpload from '@/components/FileUpload.vue'

export default {
  props: {
    id: { type: Number, default: -1 }
  },
  computed: {
    syncing() {
      let total = this.form.subItems.length
      let synced = this.form.subItems.filter(x=>x.synced ==true).length

      return `Đã đồng bộ ${synced}/${total}`
    }
  },
  components: { FileUpload },
  data() {
    return {
      valid: false,
      applying: false,
      form: {
        name: "",
        body: "",
        htmlTemplate: "",
        avatar: "",
        attachment: "",
        subItems: []
      },
      subHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Mã NV', value: 'employeeCode' },
        { text: 'Variable 1', value: 'variable1' },
        { text: 'Variable 2', value: 'variable2' },
        { text: 'Variable 3', value: 'variable3' },
        { text: 'Variable 4', value: 'variable4' },
        { text: 'Variable 5', value: 'variable5' },
        { text: 'Variable 6', value: 'variable6' },
        { text: 'Tạo bài', value: 'synced' },
        { text: 'Thao tác', value: 'actions', width: 100 },
      ]
    }
  },
  watch: {
    id: {
      immediate: true,
      async handler(newVal) {
        if (newVal !== -1) {
          try {
            // Fetch main template
            const data = await ContentTemplateApi.get(newVal)
            this.form.name = data.name || ""
            this.form.body = data.body || ""
            this.form.htmlTemplate = data.htmlTemplate || ""
            this.form.avatar = data.avatar || ""
            this.form.attachment = data.attachment || ""

            // Fetch subitems using getVariables
            const variables = await ContentTemplateApi.getVariables(newVal)
            this.form.subItems = variables.map(v => ({
              id: v.id,
              employeeCode: v.employeeCode || "",
              variable1: v.variable1 || "",
              variable2: v.variable2 || "",
              variable3: v.variable3 || "",
              variable4: v.variable4 || "",
              variable5: v.variable5 || "",
              variable6: v.variable6 || "",
              synced: v.synced,
              editing: false // start in read-only
            }))
          } catch (err) {
            console.error("Failed to fetch template or variables:", err)
          }
        } else {
          this.resetForm()
        }
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        name: "",
        body: "",
        htmlTemplate: "",
        avatar: "",
        attachment: "",
        subItems: []
      }
    },

    addRow() {
      this.form.subItems.push({
        employeeCode: "",
        variable1: "",
        variable2: "",
        variable3: "",
        variable4: "",
        templateId: this.id,
        editing: true // new row starts editable
      })
    },

    removeRow(index) {
      const item = this.form.subItems[index]
      if (item.id) {
        ContentTemplateApi.deleteVariables(this.id, item.id)
          .then(() => this.form.subItems.splice(index, 1))
          .catch(err => console.error("Failed to delete variable:", err))
      } else {
        this.form.subItems.splice(index, 1)
      }
    },

    toggleEditSave(item, index) {
      if (item.editing) {
        // Currently editing → save
        this.saveSubItem(item, index)
      }
      item.editing = !item.editing
    },

    async saveSubItem(item, index) {
      item.templateId = this.id
      try {
        if (item.id) {
          await ContentTemplateApi.putVariables(item.id, item)
          this.$set(this.form.subItems, index, { ...item, editing: false })
        } else {
          await ContentTemplateApi.postVariables(this.id, item)
          this.$set(this.form.subItems, index, { ...item, editing: false })
        }
      } catch (err) {
        console.error("Failed to save variable:", err)
      }
    },

    async submitForm() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return

      try {
        if (this.id === -1) {
          await ContentTemplateApi.post(this.form)
        } else {
          await ContentTemplateApi.put(this.id, this.form)
        }
        this.$emit("close")
        this.$emit("refresh")
      } catch (err) {
        console.error("Failed to save template:", err)
      }
    },

    applyHandler() {
    // You can implement your logic here
    // For example, send current form to an API or emit event
    
    // Example: call API to apply template
      if (this.id !== -1) {
        ContentTemplateApi.apply(this.id)
          .then(() => this.$toast?.success("Template applied successfully"))
          .catch(err => {
            console.error("Failed to apply template:", err)
            this.$toast?.error("Failed to apply template")
          })
      } else {
        this.$toast?.warning("Please save the template before applying")
      }
    },

    
    applyVariable() {
      this.applying = true
      this.form.subItems.forEach(element => {
        ContentTemplateApi.applyByVariable(this.id, element.id).then(() => {
          element.synced = true
          this.applying =false
        })
      });
    },
  },
  
}
</script>

<style scoped>
/* optional styling */
</style>
